export default {
      id: "ar-usage",
      viewBox: "0 0 49.631 37.367",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#ar",
      toString: function () {
        return this.url;
      }
    }